import React, { Fragment } from "react";
import Jibber from "/app/src/jibber";
import style from "./Item.css";
import { SVGButton, Flex, MarkdownDisplay } from "/app/src/component";

import RemoveItemModal from "/app/src/component/Modal/RemoveItemModal";

class Item extends Jibber {
  constructor(props) {
    super(props);

    this.useState({
      hover: false,
      confirmRemoval: false,
    });
  }

  render() {
    let { title, body } = this.props;
    let { toEditor, deleteFromDB } = this.props;
    return (
      <Flex
        width="100%"
        height="100px"
        backgroundColor="darkwhite"
        onMouseEnter={() => this.setHover(true)}
        onMouseLeave={() => this.setHover(false)}
        color="lightgrey"
        overflow="hidden"
      >
        <Flex column grow>
          <Flex column grow>
            <Flex className={style.FAQItemTitle}>{title}</Flex>
            <Flex className={style.FAQItemAnswer} grow>
              <MarkdownDisplay text={body} />
            </Flex>
          </Flex>
        </Flex>
        <Flex hAlignContent="center" basis="100px" column>
          {this.state.hover && (
            <Fragment>
              <SVGButton
                src="/images/Edit_M.svg"
                color="darkgrey"
                marginLeft="3px"
                hover="blue"
                onClick={toEditor}
              />
              <SVGButton
                onClick={() => this.setConfirmRemoval(true)}
                size="medium"
                color="darkgrey"
                hover="red"
                src="/images/Trash.svg"
              />
            </Fragment>
          )}
          <RemoveItemModal
            title={`Ta bort ${title}`}
            open={this.state.confirmRemoval}
            onClose={() => {
              this.setConfirmRemoval(false);
            }}
            onRemoveClick={deleteFromDB}
          />
        </Flex>
      </Flex>
    );
  }
}

export default Item;




// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ChatSettings/QuickResponse/Item/ItemNormalView.jsx